import { Linear, Sine, TimelineLite, TweenLite, TweenMax } from "gsap";
import * as HLF from "html-living-framework";
import * as Constants from "../../Data/Constants";
import * as SFX from "../../Data/SoundEffectKeys";
import { AnimatedObstacle } from "../../GameObjects/Obstacles/AnimatedObstacle";
import { BoxCollider } from "../../Physics/BoxCollider";

export class FuujinProjectile extends AnimatedObstacle {
    private static readonly SPEED: number = -250;

    constructor() {
        super(
            new HLF.SpriteAnimation(
                "fuujin-projectile-", Constants.SPRITESHEET_OBSTACLE_PREFIX + "00", 8, 2,
                10, true,
            ),
            FuujinProjectile.SPEED,
            new BoxCollider(-75, 75, -30, 30),
        );
        this._anim.anchor.set(0.5);
        this._collisionSfx = SFX.IMPACT_FUUJIN;
    }
}
